import React from 'react';

// The "Crucible Pour" mark used across the RyzenOS product, matching the
// landing page logo. `ladle` is the fill of the pour shape (light on dark
// surfaces, dark on light surfaces); the pour + drop stay brand orange.
export function RyzenMark({ size = 28, ladle = '#e8e8ec' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 46" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="RyzenOS">
      <g transform="rotate(-30 19 16)">
        <path className="rz-ladle" d="M9 9 h20 v3 l-3.5 12 c-.5 2-2 3-4 3 h-5 c-2 0-3.5-1-4-3 L9 12 Z" fill={ladle} />
      </g>
      <path d="M28 17 c3 3 5.5 6 6.5 9" stroke="#ff6a2b" strokeWidth="3.4" strokeLinecap="round" fill="none" />
      <circle cx="36" cy="34" r="6.5" fill="#ff6a2b" />
    </svg>
  );
}

// Full lockup: mark + "RyzenOS" wordmark.
export function RyzenWordmark({ height = 26, ladle = '#f4f4f5', text = '#f4f4f5' }) {
  return (
    <svg height={height} viewBox="0 0 220 48" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="RyzenOS">
      <g transform="rotate(-30 19 16)">
        <path className="rz-ladle" d="M9 9 h20 v3 l-3.5 12 c-.5 2-2 3-4 3 h-5 c-2 0-3.5-1-4-3 L9 12 Z" fill={ladle} />
      </g>
      <path d="M28 17 c3 3 5.5 6 6.5 9" stroke="#ff6a2b" strokeWidth="3.4" strokeLinecap="round" fill="none" />
      <circle cx="36" cy="34" r="6.5" fill="#ff6a2b" />
      <text x="54" y="33" fontFamily="Inter, -apple-system, sans-serif" fontSize="24" fontWeight="600" letterSpacing="-0.5" fill={text}>Ryzen<tspan fill="#ff6a2b">OS</tspan></text>
    </svg>
  );
}

export default RyzenMark;
